
export default [{
	path: '/invoices-received',
	component: () => import('@/components/invoices-received/List')
}]
